// extracted by mini-css-extract-plugin
export var icon = "link-pass-module--icon--8cddc";
export var nameText = "link-pass-module--name-text--efd08";
export var wrapper = "link-pass-module--wrapper--71fef";